export default {
  state: () => ({
    departmentsList: [
      {
        name: "Glaucoma",
        description:
          "En el área de glaucoma proporcionamos tratamientos variados con los últimos tipos de láser CicloG6, Yag Láser, gonioscopía digital y monitoreo de la presión intraocular MAPIO. También realizamos cirugías estéticas de re-juvenecimiento facial y del contorno de ojos realizando blefaroplastia, láser IPL. ",
        otherAreas: true,
      },
      {
        name: "Refractiva",
        description:
          "En el área de glaucoma proporcionamos tratamientos variados con los últimos tipos de láser CicloG6, Yag Láser, gonioscopía digital y monitoreo de la presión intraocular MAPIO. También realizamos cirugías estéticas de re-juvenecimiento facial y del contorno de ojos realizando blefaroplastia, láser IPL. ",
        otherAreas: false,
      },
      {
        name: "Córnea",
        description:
          "En el área de glaucoma proporcionamos tratamientos variados con los últimos tipos de láser CicloG6, Yag Láser, gonioscopía digital y monitoreo de la presión intraocular MAPIO. También realizamos cirugías estéticas de re-juvenecimiento facial y del contorno de ojos realizando blefaroplastia, láser IPL. ",
         otherAreas: true,
      },
      {
        name: "Retina",
        description:
          "En el área de glaucoma proporcionamos tratamientos variados con los últimos tipos de láser CicloG6, Yag Láser, gonioscopía digital y monitoreo de la presión intraocular MAPIO. También realizamos cirugías estéticas de re-juvenecimiento facial y del contorno de ojos realizando blefaroplastia, láser IPL. ",
         otherAreas: true,
      },
      {
        name: "Oculoplastía",
        description:
          "En el área de glaucoma proporcionamos tratamientos variados con los últimos tipos de láser CicloG6, Yag Láser, gonioscopía digital y monitoreo de la presión intraocular MAPIO. También realizamos cirugías estéticas de re-juvenecimiento facial y del contorno de ojos realizando blefaroplastia, láser IPL. ",
         otherAreas: false,
      },
      {
        name: "Estrabismo",
        description:
          "En el área de glaucoma proporcionamos tratamientos variados con los últimos tipos de láser CicloG6, Yag Láser, gonioscopía digital y monitoreo de la presión intraocular MAPIO. También realizamos cirugías estéticas de re-juvenecimiento facial y del contorno de ojos realizando blefaroplastia, láser IPL. ",
         otherAreas: false,
      },
      {
        name: "Uveóloga",
        description:
          "En el área de glaucoma proporcionamos tratamientos variados con los últimos tipos de láser CicloG6, Yag Láser, gonioscopía digital y monitoreo de la presión intraocular MAPIO. También realizamos cirugías estéticas de re-juvenecimiento facial y del contorno de ojos realizando blefaroplastia, láser IPL. ",
         otherAreas: true,
      },
      {
        name: "Neurooftalmología",
        description:
          "En el área de glaucoma proporcionamos tratamientos variados con los últimos tipos de láser CicloG6, Yag Láser, gonioscopía digital y monitoreo de la presión intraocular MAPIO. También realizamos cirugías estéticas de re-juvenecimiento facial y del contorno de ojos realizando blefaroplastia, láser IPL. ",
         otherAreas: true,
      },
    ],
  }),
  getters: {
    getDepartments: (state) => state.departmentsList,
  },
  mutations: {},
  actions: {},
  namespaced: true,
};
